// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:11-10-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION

import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import groupReportTypes from './group.report.types';
import { getAllGroupReport } from './group.report.services';
import {
	fetchAllGroupReportFailure,
	fetchAllGroupReportResponseResetChanged,
	fetchAllGroupReportSuccess,
} from './group.report.action';

/** *********************  START ALL GROUP REPORT DETAILS  ******************** */
export function* getAllGroupReportDetail({ payload }: any) {
	try {
		const key = 'GetAllGroupReportKey';
		const {
			companyID,
			databaseName,
			branchID,
			funderID,
			IsPersonalLoan,
			centerID,
			toDate,
			fromDate,
			SearchType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			FunderID: funderID,
			IsPersonalLoan: IsPersonalLoan,
			LocationID: centerID,
			ToDate: toDate,
			FromDate: fromDate,
			TillDate: toDate,
			SearchType: SearchType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllGroupReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllGroupReportFailure(responseData.data));
		} else {
			yield put(fetchAllGroupReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllGroupReportFailure(error));
	}
}

export function* reserAllGroupReportResponse() {
	yield put(fetchAllGroupReportResponseResetChanged());
}

export function* onAllGroupReportDetail() {
	yield takeLatest(groupReportTypes.GET_GROUP_REPORT_START, getAllGroupReportDetail);
}

export function* onAllGroupReportDetailResponseReset() {
	yield takeLatest(
		groupReportTypes.GET_GROUP_REPORT_RESPONSE_RESET_START,
		reserAllGroupReportResponse,
	);
}
/** *********************  END ALL GROUP REPORT DETAILS ******************** */

export function* groupReportSaga() {
	yield all([call(onAllGroupReportDetail), call(onAllGroupReportDetailResponseReset)]);
}
